import { css } from '@emotion/react';
import { Theme } from '@mui/material';
import { THEME_MODE } from '@state-mgmt/slices/appSlice';

export const styles = {
  scrollableArea: (theme: Theme) => css`
    flex-grow: 1;
    padding: ${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(4)};
    overflow-y: scroll;
  `,
  card: (theme: Theme, themeMode: THEME_MODE) => css`
    margin-bottom: ${theme.spacing(1.5)};
    border-radius: 12px;
    border: 1px solid ${themeMode === THEME_MODE.DARK ? 'rgba(255, 255, 255, 0.12)' : theme.palette.divider};
    background-color: ${themeMode === THEME_MODE.DARK ? 'rgb(53, 54, 58)' : '#f1f1f1'};
    box-shadow: none;
    overflow: hidden;
  `,
  cardContent: css`
    padding: 16px !important;

    &:last-child {
      padding-bottom: 16px !important;
    }
  `,
  cardTitle: css`
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    margin-bottom: 12px;
  `,
  controlGroup: (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `,
  checkboxGroup: css`
    display: flex;
    flex-direction: column;
    gap: 2px;
  `,
  formControlLabel: css`
    margin-left: 0;
    margin-right: 0;
  `,
  nestedControl: (theme: Theme) => css`
    margin-top: ${theme.spacing(0.5)};
    padding-left: ${theme.spacing(1)};
  `,
  warningBox: (theme: Theme, themeMode: THEME_MODE) => css`
    margin-top: ${theme.spacing(1.5)};
    padding: ${theme.spacing(1.25)} ${theme.spacing(1.5)};
    border-radius: 8px;
    background-color: ${themeMode === THEME_MODE.DARK ? 'rgba(255, 255, 255, 0.06)' : 'rgba(25, 26, 31, 0.08)'};
    font-size: 13px;
    line-height: 1.4;
    color: ${themeMode === THEME_MODE.DARK ? '#bdbdc0' : theme.palette.text.secondary};
  `,
  treatmentZonesContainer: css`
    gap: 12px;
    display: flex;
    flex-direction: column;
    padding: 8px 0;
  `,
  treatmentZone: css`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  treatmentZoneBullet: (color: string) => css`
    z-index: 1000;
    width: 10px;
    height: 10px;
    padding: 8px;
    background-color: ${color};
    box-shadow: inset 0 0 10px black;
    transform: rotate(45deg);
  `,
  treatmentZoneLabel: css`
    flex-grow: 1;
    margin-left: 8px;
    font-size: 14px;
  `
};
